import React from "react";
import styled from 'styled-components';
import { colours } from "../Styles";
import FlexCenterCenter from "./FlexCenterCenter";

function ContactItem(props) {
    const { light, medium } = colours;
    const ContactItem = styled.a`
        width: max-content;
        cursor: pointer;
        font-size: 14px;
        font-weight: 100;
        font-family: "Play", sans-serif;
        color: ${light};
        transition: 500ms;
        :hover {
            color: ${medium};
            svg {
                fill: ${medium};
            }
        }
         svg {
            fill: ${light};
            transition: 500ms;
            margin: 10px;
        }
        .item-content {
            margin-left: -5px;
        }
        @media only screen and (max-width: 600px) 
        {
        }
    `;

    var tar = '';
    props.url.startsWith('#') ? tar = '' : tar = '_blank';

  return (
    <ContactItem href={props.url} target={tar} rel="noopener noreferrer">
        <FlexCenterCenter>
            {props.icon}
            {props.content ? <div className="item-content">{props.content}</div> : <div>{props.content}</div>}
        </FlexCenterCenter>
    </ContactItem>
  );
}

export default ContactItem;
